import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CartCookieService } from '@core/services/storage/cart/cart-cookie.service';

export const clearCookieGuard: CanActivateFn = () => {
    const cartCookieService = inject(CartCookieService);

    // pulizia indirizzo spedizione del cookie
    cartCookieService.setIndirizzo(null, false);

    // pulizia coupon del cookie
    cartCookieService.setCoupon('', false);

    // pulizia rapidoh e speedy
    cartCookieService.setCartRapidoh(false, false);

    // pulizia spedizione assicurata
    cartCookieService.setSpedizioneAssicurata(false, false);

    // pulizia richiesta fattura
    cartCookieService.setRichiestaFattura(false, false);

    // pulizia ritiro in sede
    cartCookieService.setDeliveryMode();

    return true;
};